import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      try {
        // Route is /auth/verify-email (src/backend/routes/auth.js). The old
        // /auth/users/verify-email path 404'd, so every confirmation link in
        // every registration email failed with a generic error.
        await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/verify-email`, {
          params: { token },
        });
        setStatus('success');
      } catch (error) {
        setStatus('error');
      }
    };

    verifyEmail();
  }, [location.search, navigate]);

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 5, textAlign: 'center' }}>
      {status === 'loading' && <CircularProgress />}
      {status === 'success' && (
        <>
          <Alert severity="success">{t('verifyEmail.successMessage')}</Alert>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => navigate('/login')}
          >
            {t('verifyEmail.goToLogin', 'Go to Login')}
          </Button>
        </>
      )}
      {status === 'error' && <Alert severity="error">{t('verifyEmail.errorMessage')}</Alert>}
    </Box>
  );
};

export default VerifyEmail;
